// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-slide img{/* 這段代碼實現banner隨着屏幕自適應大小*/\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
